import React from 'react';
import styled from 'styled-components';
import { useRouter } from 'next/router';
import { Typography } from '@ntuctech/devex-tangram';

import { SCREEN_SIZE } from '../../lib/mediaQuery';

const BreadCrumbContainer = styled.div`
  display: flex;
  ${SCREEN_SIZE.From.Tablet} {
    margin: 3rem 0 0;
  }

  ${SCREEN_SIZE.Below.MobileL} {
    margin: 1rem 0 0;
    padding: ${(p) => (p.isMyorder ? 0 : '1.25rem 1rem 0 1rem')};
  }
`;

const StyledLink = styled.span`
  span {
    font-weight: 400;
    ${(props) =>
      props.isActive ? 'color: #333333 !important;' : 'color: #1454B8; cursor: pointer;'}
  }
`;

const StyledSlash = styled.span`
  margin: 0 0.5rem;
`;

const BreadCrumb = ({ isB2B, isMyorder }) => {
  const router = useRouter();
  const homeLabel = isB2B ? 'Business' : 'Personal';

  const b2cSteps = [
    {
      name: `E-Gift Vouchers (${homeLabel})`,
      location: '/',
    },
    {
      name: 'Pick a design',
      location: '/customise-voucher/',
    },
    {
      name: 'Cart',
      location: '/cart/',
    },
    {
      name: 'Payment',
      location: '/payment',
    },
  ];

  const b2bSteps = [
    {
      name: `E-Gift Vouchers (${homeLabel})`,
      location: '/',
    },
    {
      name: 'My orders',
      location: '/my-orders/',
    },
    {
      name: 'Pick a design',
      location: '/customise-voucher/',
    },
    {
      name: 'Cart',
      location: '/cart/',
    },
    {
      name: 'Payment',
      location: '/payment',
    },
  ];

  const currentRoute = `${router?.pathname}/`;
  const steps = isB2B ? b2bSteps : b2cSteps;
  const getCurrentIndex = steps.findIndex((item) => item.location.includes(currentRoute));
  const breadCrumbs = steps.map((item) => ({
    ...item,
    isActive: currentRoute === item.location,
  }));
  const slicedBreadCrumbs = breadCrumbs.slice(0, getCurrentIndex + 1);

  return (
    <BreadCrumbContainer isB2B={isB2B} isMyorder={isMyorder}>
      {slicedBreadCrumbs.map((step, index) => {
        const isLast = slicedBreadCrumbs.length === index + 1;
        return (
          <React.Fragment key={`breadcrumb-${step.location}`}>
            <StyledLink isActive={step.isActive}>
              <Typography
                onClick={() => {
                  window.location.href = step.location;
                }}
                disabled={step.isActive}
                href={step.location}
                variant="caption1Regular"
                data-testid={`breadcrumb-${index}`}
              >
                {step.name}
              </Typography>
            </StyledLink>
            {!isLast ? <StyledSlash>/</StyledSlash> : ''}{' '}
          </React.Fragment>
        );
      })}
    </BreadCrumbContainer>
  );
};

export default BreadCrumb;
